import { formatMedium } from "services/formatMedium";
import {
	Event,
	formatBasicMeetingDetails
} from "services/formatBasicMeetingDetails";
import { Medium } from "hooks/useAvailableMediums";

export function formatMeetingDetailsForAttendees(
	event: Event & { medium: Medium },
	currentUid: string,
	useShortFormat: boolean,
	timezone: string
) {
	const { medium } = event;

	return {
		...formatBasicMeetingDetails(event, currentUid, useShortFormat, timezone),
		medium: formatMedium(medium)
	};
}
